// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import {
    getFirestore,
    doc,
    getDoc,
    updateDoc,
    arrayUnion,
    setDoc,
} from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCRbLRh636GSuNWSrL3f0plragVtJ-JoH4",
    authDomain: "project-movie-organizer.firebaseapp.com",
    databaseURL: "https://project-movie-organizer-default-rtdb.firebaseio.com",
    projectId: "project-movie-organizer",
    storageBucket: "project-movie-organizer.appspot.com",
    messagingSenderId: "97809097435",
    appId: "1:97809097435:web:2a76cd32492e781efea2fe",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, GoogleAuthProvider, signInWithPopup, db };

// Function to get the user's watchlist from Firebase
export const getWatchlist = async (userId) => {
    const watchlistRef = doc(db, "watchlists", userId);
    const watchlistSnapshot = await getDoc(watchlistRef);

    if (watchlistSnapshot.exists()) {
        return watchlistSnapshot.data().movies || [];
    }

    return [];
};

// Function to add a movie to the user's watchlist in Firebase
export const addToWatchlist = async (userId, movie) => {
    const watchlistRef = doc(db, "watchlists", userId);

    // Check if the document exists
    const watchlistSnapshot = await getDoc(watchlistRef);

    if (watchlistSnapshot.exists()) {
        // Document exists, update it
        await updateDoc(watchlistRef, {
            movies: arrayUnion({
                id: movie.id,
                title: movie.title,
                poster_path: movie.poster_path,
                release_date: movie.release_date,
            }),
        });
    } else {
        // Document doesn't exist, create it using setDoc
        await setDoc(watchlistRef, {
            movies: [
                {
                    id: movie.id,
                    title: movie.title,
                    poster_path: movie.poster_path,
                    release_date: movie.release_date,
                },
            ],
        });
    }
};

// Function to remove a movie from the user's watchlist in Firebase
export const removeFromWatchlist = async (userId, movieId) => {
    try {
        const watchlistRef = doc(db, "watchlists", userId);

        // Get the current watchlist data
        const watchlistSnapshot = await getDoc(watchlistRef);
        const currentMovies = watchlistSnapshot.data().movies || [];

        // Check if the movieId exists in the current watchlist
        const updatedMovies = currentMovies.filter(
            (movie) => movie.id !== movieId
        );

        // Update the watchlist with the filtered movies
        await updateDoc(watchlistRef, {
            movies: updatedMovies,
        });
    } catch (error) {
        console.error("Error removing movie from watchlist:", error);
    }
};

// Function to check if a movie is in the user's watchlist in Firebase
export const isMovieInWatchlist = async (userId, movieId) => {
    const watchlistRef = doc(db, "watchlists", userId);
    const watchlistSnapshot = await getDoc(watchlistRef);

    if (watchlistSnapshot.exists()) {
        const movies = watchlistSnapshot.data().movies || [];
        return movies.some((movie) => movie.id === movieId);
    }

    return false;
};

// Function to get the user's likedlist from Firebase
export const getLikedlist = async (userId) => {
    const likedlistRef = doc(db, "likedlists", userId);
    const likedlistSnapshot = await getDoc(likedlistRef);

    if (likedlistSnapshot.exists()) {
        return likedlistSnapshot.data().movies || [];
    }

    return [];
};

// Function to add a movie to the user's likedlist in Firebase
export const addToLikedlist = async (userId, movie) => {
    const likedlistRef = doc(db, "likedlists", userId);

    // Check if the document exists
    const likedlistSnapshot = await getDoc(likedlistRef);

    if (likedlistSnapshot.exists()) {
        // Document exists, update it
        await updateDoc(likedlistRef, {
            movies: arrayUnion({
                id: movie.id,
                title: movie.title,
                poster_path: movie.poster_path,
                release_date: movie.release_date,
            }),
        });
    } else {
        // Document doesn't exist, create it using setDoc
        await setDoc(likedlistRef, {
            movies: [
                {
                    id: movie.id,
                    title: movie.title,
                    poster_path: movie.poster_path,
                    release_date: movie.release_date,
                },
            ],
        });
    }
};

// Function to remove a movie from the user's watchlist in Firebase
export const removeFromLikedlist = async (userId, movieId) => {
    try {
        const likedlistRef = doc(db, "likedlists", userId);

        // Get the current watchlist data
        const likedlistSnapshot = await getDoc(likedlistRef);
        const currentMovies = likedlistSnapshot.data().movies || [];

        // Check if the movieId exists in the current watchlist
        const updatedMovies = currentMovies.filter(
            (movie) => movie.id !== movieId
        );

        // Update the watchlist with the filtered movies
        await updateDoc(likedlistRef, {
            movies: updatedMovies,
        });
    } catch (error) {
        console.error("Error removing movie from likedlist:", error);
    }
};

// Function to check if a movie is in the user's watchlist in Firebase
export const isMovieInLikedlist = async (userId, movieId) => {
    const likedlistRef = doc(db, "likedlists", userId);
    const likedlistSnapshot = await getDoc(likedlistRef);

    if (likedlistSnapshot.exists()) {
        const movies = likedlistSnapshot.data().movies || [];
        return movies.some((movie) => movie.id === movieId);
    }

    return false;
};
